<template>
    <div class="complaint-container">
        <van-form @submit.prevent="onSubmit">
            <van-cell-group>
                <van-field v-model="form.type" name="type" :label="riverLabel" placeholder="请选择" is-link readonly
                    @click="goToLists" :rules="[{ required: true, message: '请选择' }]" />

                <van-field v-model="form.name" name="name" :label="complaintType + '人姓名'" placeholder="请输入姓名"
                    :rules="[{ required: true, message: '请填写姓名' }]" />
                <van-field v-model="form.phone" name="phone" :label="complaintType + '人电话'" placeholder="请输入联系电话"
                    :rules="[{ required: true, pattern: /^1[3-9]\d{9}$/, message: '请填写正确的手机号码' }]" />
                <van-field v-model="form.theme" name="theme" :label="complaintType + '主题'" placeholder="请输入主题"
                    :rules="[{ required: true, message: '请输入主题' }]" />
                <van-field v-model="form.content" name="content" label="内容描述" type="textarea" placeholder="不超过200个字"
                    rows="4" autosize :rules="[{ required: true, message: '请填写问题描述' }]" />

                <van-cell title="图片">
                    <template #label>
                        <!-- 添加相机按钮 -->
                        <div class="camera-buttons">
                            <van-button type="primary" icon="photograph"
                                @click.prevent="showMediaOptions">图片上传</van-button>
                        </div>

                        <!-- 添加图片预览区域 -->
                        <div class="image-preview-container" v-if="fileList && fileList.length > 0">
                            <div class="image-preview-item" v-for="(item, index) in fileList" :key="index">
                                <img :src="item.baseurl" class="preview-image" @click="previewImage(index)">
                                <div class="image-delete-icon" @click.stop="handleImageDeleteTest(item, index)">
                                    <van-icon name="cross" />
                                </div>
                                <!-- 添加上传状态显示 -->
                                <div :class="['upload-status', item.status]" v-if="item.status !== 'done'">
                                    {{ item.status === 'uploading' ? '上传中...' : '上传失败' }}
                                </div>
                            </div>
                        </div>
                    </template>
                </van-cell>
                <van-field name="switch" label="匿名投诉">
                    <template #input>
                        <van-switch v-model="switchChecked" size="20" />
                    </template>
                    <template #extra>
                        <span class="tip-text">(温馨提示:您的个人信息和联系方式不会向河长公布，但河长办、上级管理部门可以查看。)</span>
                    </template>
                </van-field>

            </van-cell-group>
            <div style="margin: 16px;display: flex;">
                <!-- 修改按钮的点击事件处理 -->
                <van-button type="info" block :loading="isSubmitting" loading-text="提交中..."
                    @click.prevent="onSubmit">提交</van-button>
                <van-button type="default" block style="margin-left: 10px;" :disabled="isSubmitting"
                    @click.prevent="cancel">取消</van-button>
            </div>
        </van-form>
    </div>
</template>

<script>
import { post } from '@/utils/api';
import { appOrPC, ipType, IMAGE_URL, interface_pubkey1, interface_prikey1, IMAGE_BASE_URL } from '@/utils/config';
export default {
    name: 'ComplaintPage',
    data() {
        return {
            form: {
                name: localStorage.getItem('complaintPersonInfo') !== null ? JSON.parse(localStorage.getItem('complaintPersonInfo')).personName : "",
                phone: localStorage.getItem('complaintPersonInfo') !== null ? JSON.parse(localStorage.getItem('complaintPersonInfo')).personPhone : "",
                theme: '',
                type: '',
                content: '',
                latitude: 0,
                longitude: 0
            },
            selectedType: '',
            // showTypePicker: false,
            switchChecked: false,
            typeOptions: [
                '水质问题',
                '河道污染',
                '非法捕捞',
                '其他问题'
            ],
            riverLabel: '',
            complaintType: '',
            fileList: [],
            issueImages: [],
            isSubmitting: false, // 添加提交状态标记
        }
    },
    mounted() {
        const type = this.$route.params.type;
        const value = this.$route.params.value;
        this.riverLabel = type + value
        this.complaintType = type
        if (localStorage.getItem('riverSelectedName') !== "") this.form.type = localStorage.getItem('riverSelectedName');
        this.getCurrentLocation()
        // if (type) {
        //   console.log(type, value,)
        //   this.selectedType = type;
        //   this.form.type = this.getTypeLabel(type);
        // }
    },
    methods: {
        onSubmit() {
            // 确保事件对象存在时才调用preventDefault
            if (event && typeof event.preventDefault === 'function') {
                event.preventDefault();
            }
            // 防止重复提交
            if (this.isSubmitting) {
                this.$toast('正在提交，请稍候...');
                return;
            }

            // 检查表单必填项
            if (!this.form.type || !this.form.name || !this.form.phone || !this.form.theme || !this.form.content) {
                this.$toast('请填写完整信息');
                return;
            }

            // 检查手机号格式
            if (!/^1[3-9]\d{9}$/.test(this.form.phone)) {
                this.$toast('请填写正确的手机号码');
                return;
            }

            // 检查是否有正在上传的图片
            const uploadingImages = this.fileList.filter(item => item.status === 'uploading');
            if (uploadingImages.length > 0) {
                this.$toast('有图片正在上传，请等待上传完成');
                return;
            }

            this.issueImages = [];
            // 从fileList中提取图片ID
            for (let i = 0; i < this.fileList.length; i++) {
                const element = this.fileList[i];
                if (element.status === 'done' && element.content) {
                    this.issueImages.push(element.content);
                } else if (element.status === 'done' && element.imageId) {
                    this.issueImages.push(element.imageId);
                }
            }
            console.log('提交的图片IDs:', this.issueImages);
            console.log('位置信息:', this.form.longitude, this.form.latitude);

            // 调用提交方法
            this.addComplaint();
        },
        async addComplaint() {
            try {
                this.isSubmitting = true; // 设置提交状态

                let p = JSON.parse(localStorage.getItem('complaintPersonInfo'))
                if (!p) {
                    this.$toast.fail('获取用户信息失败');
                    this.isSubmitting = false;
                    return;
                }

                if (appOrPC) {
                    let that = this, extraData = {
                        header: {
                            Authorization: "Bearer " + localStorage.getItem("token"),
                            "App-Version-Code": "v2.0.0"
                        }
                    }
                    vaildInterfacefn(
                        "hhwzzcsesonq",
                        "rcshhwtyjksc",
                        SM.encrypt(JSON.stringify({
                            ipType: ipType,
                            methodType: "post",
                            methodName: "api/app/issue/complaint/add",
                            "patrolId": 0,
                            "geospatialId": localStorage.getItem('riverSelectedId'),//要投诉建议的河湖湾ID
                            "type": that.complaintType === "投诉" ? 2 : 3,
                            "personId": 0,
                            "personType": 1,
                            "personName": p.personName,
                            "personPhone": p.personPhone,
                            "personUserId": p.personUserId,
                            "personUserName": p.personUserName,
                            "longitude": that.form.longitude,
                            "latitude": that.form.latitude,
                            "anonymity": that.switchChecked ? 1 : 2,
                            "issueTitle": that.form.theme,
                            "issueContent": that.form.content,
                            "issueImages": that.issueImages
                        }), interface_pubkey1),
                        "1",
                        extraData
                    ).then((value) => {
                        that.isSubmitting = false; // 重置提交状态
                        if (value == false) {
                            that.$toast.fail('提交失败');
                            return;
                        } else {
                            const de_value = JSON.parse(SM.decrypt(value, interface_prikey1))
                            console.log("问题提交：", de_value);
                            if (de_value.code == 200 && de_value.success) {
                                that.$toast.success('提交成功')
                                that.$router.go(-1)
                            } else {
                                that.$toast.fail(de_value.message || '提交失败');
                            }
                        }
                    }).catch(error => {
                        console.error('提交失败:', error);
                        that.isSubmitting = false; // 重置提交状态
                        that.$toast.fail('提交失败，请重试');
                    });
                } else {
                    try {
                        const param = {
                            "patrolId": 0,
                            "geospatialId": localStorage.getItem('riverSelectedId'),//要投诉建议的河湖湾ID
                            "type": this.complaintType === "投诉" ? 2 : 3,
                            "personId": 0,
                            "personType": 1,
                            "personName": p.personName,
                            "personPhone": p.personPhone,
                            "personUserId": p.personUserId,
                            "personUserName": p.personUserName,
                            "longitude": this.form.longitude,
                            "latitude": this.form.latitude,
                            "anonymity": this.switchChecked ? 1 : 2,
                            "issueTitle": this.form.theme,
                            "issueContent": this.form.content,
                            "issueImages": this.issueImages
                        };
                        const res = await post('/issue/complaint/add', param);
                        console.log(res);
                        this.isSubmitting = false; // 重置提交状态

                        if (res.code == 200 && res.success) {
                            this.$toast.success('提交成功')
                            this.$router.go(-1)
                        } else {
                            this.$toast.fail(res.message || '提交失败');
                        }
                    } catch (error) {
                        console.error('提交失败:', error);
                        this.isSubmitting = false; // 重置提交状态
                        this.$toast.fail('提交失败，请重试');
                    }
                }
            } catch (error) {
                console.error('提交过程发生错误:', error);
                this.isSubmitting = false; // 重置提交状态
                this.$toast.fail('提交失败，请重试');
            }
        },
        cancel() {
            this.$dialog.confirm({
                title: '提示',
                message: '您要放弃这条投诉内容吗？',
            })
                .then(() => {
                    // on confirm          
                    this.$router.go(-1)
                })
                .catch(() => {
                    // on cancel
                });
        },
        // afterRead(file) {
        //   此时可以自行将文件上传至服务器
        //   console.log(file, this.fileList);
        //   this.issueImages.push(file.content)
        //   console.log(this.issueImages,)
        // },

        // 显示媒体选择弹窗
        showMediaOptions() {
            console.log('显示媒体选择弹窗');
            try {
                // 检查是否有lightAppJssdk
                console.log('lightAppJssdk:', lightAppJssdk);

                if (typeof lightAppJssdk !== 'undefined' && lightAppJssdk.notification && lightAppJssdk.notification.showMediaAlert) {
                    var data = ["相册", "相机", "视频"];
                    lightAppJssdk.notification.showMediaAlert({
                        arg0: data,
                        success: (data) => {
                            console.log('选择媒体类型:', data);
                            // 获取token并添加Bearer前缀
                            const token = localStorage.getItem('token') || sessionStorage.getItem('token') || '';
                            const bearerToken = token ? `Bearer ${token}` : '';
                            var pam1 = {
                                "url": `${IMAGE_BASE_URL}/common/upload`, // 使用完整的上传接口URL
                                "fileKey": "file", // 修改为"file"，与后端接口匹配
                                "params": {
                                    "token": bearerToken,
                                    "udid": "863654024080715",
                                    "uniquecode": "1704358088779",
                                    "tokenuuid": "3d7e920bbdc922bf27ab490105e27971"
                                },
                                "header": {
                                    "token": bearerToken,
                                    "Authorization": bearerToken,
                                    "Content-Type": "multipart/form-data" // 确保设置正确的Content-Type
                                },
                                "chooseType": "chooseImageUpload",
                                "transmissionType": 1, // 0-图片地址
                                "maxSize": 50,
                                "maxSelectNum": 1
                            };
                            if (data.index == 0) {
                                console.log('选择相册');
                                pam1.chooseType = "chooseImageUpload";
                            } else if (data.index == 1) {
                                console.log('选择相机');
                                pam1.chooseType = "takingPicturesUpload";
                            } else if (data.index == 2) {
                                console.log('选择视频');
                                pam1.chooseType = "takingVideoUpload"
                            }

                            this.chooseFileUploadTest(pam1);
                        },
                        fail: (data) => {
                            console.error('媒体选择失败:', data);
                            this.$toast('媒体选择失败');
                        }
                    });
                } else {
                    console.warn('lightAppJssdk不可用，使用备用方法');
                    // 如果SDK不可用，使用之前的方法
                    if (window.android && typeof window.android.takePicture === 'function') {
                        window.android.takePicture();
                    } else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.takePicture) {
                        window.webkit.messageHandlers.takePicture.postMessage({});
                    } else {
                        this.takePictureFromNative(); // 使用之前的备用方法
                    }
                }
            } catch (error) {
                console.error('显示媒体选择弹窗失败:', error);
                this.$toast('调用相机功能失败');
                // 使用备用方法
                this.takePictureFromNative();
            }
        },

        // 处理文件上传
        chooseFileUploadTest(pam) {
            console.log('开始文件上传:', pam);
            try {
                if (typeof lightAppJssdk !== 'undefined' && lightAppJssdk.uploadFile && lightAppJssdk.uploadFile.chooseFileUpload) {
                    lightAppJssdk.uploadFile.chooseFileUpload({
                        arg0: pam,
                        success: async (data) => {
                            try {
                                // 解析返回的数据
                                console.log('文件上传原始数据:', data);

                                if (typeof data === 'string') {
                                    // 检查是否是 base64 格式
                                    if (data.startsWith('[\"') || data.startsWith('["')) {
                                        // 移除多余的转义字符并解析
                                        const cleanData = data.replace(/\\/g, '');

                                        try {
                                            const base64Data = JSON.parse(cleanData)[0];

                                            // 为base64图片创建一个完整的Data URL
                                            const imageBase64Url = base64Data.startsWith('data:')
                                                ? base64Data
                                                : `data:image/jpeg;base64,${base64Data}`;

                                            // 将base64转换为Blob对象
                                            const byteString = atob(imageBase64Url.split(',')[1]);
                                            const mimeString = imageBase64Url.split(',')[0].split(':')[1].split(';')[0];
                                            const ab = new ArrayBuffer(byteString.length);
                                            const ia = new Uint8Array(ab);
                                            for (let i = 0; i < byteString.length; i++) {
                                                ia[i] = byteString.charCodeAt(i);
                                            }
                                            const blob = new Blob([ab], { type: mimeString });

                                            // 创建File对象
                                            const file = new File([blob], `photo_${Date.now()}.jpg`, { type: mimeString || 'image/jpeg' });

                                            // 创建临时文件对象并添加到fileList，显示上传中状态
                                            const tempFileObj = {
                                                status: 'uploading',
                                                baseurl: imageBase64Url, // 先用base64显示
                                                imageId: Date.now(),
                                                message: '上传中...',
                                                url: imageBase64Url
                                            };

                                            this.fileList.push(tempFileObj);

                                            // 创建表单数据
                                            const formData = new FormData();
                                            formData.append('file', file);    // 直接传入文件名和文件对象

                                            // 保存this引用
                                            const that = this;

                                            if (appOrPC) {
                                                // APP环境下的处理
                                                const extraData = {
                                                    header: {
                                                        Authorization: "Bearer " + localStorage.getItem("token"),
                                                        "App-Version-Code": "v2.0.0",
                                                        'Content-Type': 'multipart/form-data',
                                                    },
                                                };

                                                try {
                                                    // 使用Promise处理异步上传
                                                    await new Promise((resolve, reject) => {
                                                        vaildInterfacefn(
                                                            "hhwzzcsesonq",
                                                            "rcshhwtyjksc",
                                                            SM.encrypt(JSON.stringify({
                                                                ipType: ipType,
                                                                methodType: "FDPOST",
                                                                methodName: "api/common/upload",
                                                                file: base64Data
                                                            }), interface_pubkey1),
                                                            "1",
                                                            extraData
                                                        ).then((value) => {
                                                            console.log('解密前的数据:', value);
                                                            if (value == false) {
                                                                reject(new Error('上传失败，返回值为false'));
                                                                return;
                                                            }

                                                            try {
                                                                const de_value = JSON.parse(SM.decrypt(value, interface_prikey1));
                                                                console.log('解密后的数据:', de_value);

                                                                if (de_value && de_value.code == 200 && de_value.success && de_value.data) {
                                                                    // 直接在这里处理上传成功的逻辑
                                                                    const imageId = de_value.data;

                                                                    // 构建完整的图片URL
                                                                    let imageUrl = IMAGE_BASE_URL;
                                                                    if (!imageUrl.endsWith('/')) {
                                                                        imageUrl += '/';
                                                                    }
                                                                    imageUrl += `common/image?id=${imageId}`;

                                                                    // 添加token参数
                                                                    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
                                                                    if (token) {
                                                                        imageUrl = imageUrl + (imageUrl.includes('?') ? '&' : '?') + `token=${encodeURIComponent(token)}`;
                                                                    }

                                                                    console.log('处理后的图片URL:', imageUrl);

                                                                    // 更新文件对象状态
                                                                    const fileIndex = that.fileList.findIndex(f => f === tempFileObj);
                                                                    if (fileIndex !== -1) {
                                                                        that.$set(that.fileList, fileIndex, {
                                                                            status: 'done',
                                                                            url: imageUrl,
                                                                            imageId: imageId,
                                                                            baseurl: imageBase64Url,
                                                                            content: imageId // 添加content字段用于提交
                                                                        });
                                                                    }

                                                                    that.$toast.success('图片上传成功');
                                                                    resolve();
                                                                } else {
                                                                    that.$toast.fail(de_value?.message || '上传失败');

                                                                    // 更新文件状态为失败
                                                                    const fileIndex = that.fileList.findIndex(f => f === tempFileObj);
                                                                    if (fileIndex !== -1) {
                                                                        that.$set(that.fileList, fileIndex, {
                                                                            status: 'failed',
                                                                            url: imageBase64Url,
                                                                            message: '上传失败',
                                                                            baseurl: imageBase64Url,
                                                                        });
                                                                    }
                                                                    reject(new Error(de_value?.message || '上传失败'));
                                                                }
                                                            } catch (jsonError) {
                                                                console.error('JSON解析失败:', jsonError);
                                                                that.$toast.fail('数据解析失败');

                                                                // 更新文件状态为失败
                                                                const fileIndex = that.fileList.findIndex(f => f === tempFileObj);
                                                                if (fileIndex !== -1) {
                                                                    that.$set(that.fileList, fileIndex, {
                                                                        status: 'failed',
                                                                        url: imageBase64Url,
                                                                        message: '解析失败',
                                                                        baseurl: imageBase64Url,
                                                                    });
                                                                }
                                                                reject(jsonError);
                                                            }
                                                        }).catch(error => {
                                                            console.error('上传处理错误:', error);
                                                            that.$toast.fail('上传处理失败');

                                                            // 更新文件状态为失败
                                                            const fileIndex = that.fileList.findIndex(f => f === tempFileObj);
                                                            if (fileIndex !== -1) {
                                                                that.$set(that.fileList, fileIndex, {
                                                                    status: 'failed',
                                                                    url: imageBase64Url,
                                                                    message: '处理失败',
                                                                    baseurl: imageBase64Url,
                                                                });
                                                            }
                                                            reject(error);
                                                        });
                                                    });
                                                } catch (appUploadError) {
                                                    console.error('APP环境上传失败:', appUploadError);
                                                    throw appUploadError; // 向外层抛出错误
                                                }
                                            } else {
                                                // PC环境下的处理
                                                try {
                                                    // 异步上传图片
                                                    const response = await post('/common/upload', formData, {
                                                        headers: { 'Content-Type': 'multipart/form-data' },
                                                    });

                                                    if (!response || response.code !== 200 || !response.data) {
                                                        throw new Error(response?.message || '上传失败');
                                                    }

                                                    // 上传成功，处理图片URL和状态更新
                                                    const imageId = response.data;

                                                    // 构建完整的图片URL
                                                    let imageUrl = IMAGE_BASE_URL;
                                                    if (!imageUrl.endsWith('/')) {
                                                        imageUrl += '/';
                                                    }
                                                    imageUrl += `common/image?id=${imageId}`;

                                                    // 添加token参数
                                                    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
                                                    if (token) {
                                                        imageUrl = imageUrl + (imageUrl.includes('?') ? '&' : '?') + `token=${encodeURIComponent(token)}`;
                                                    }

                                                    console.log('处理后的图片URL:', imageUrl);

                                                    // 更新文件对象状态
                                                    const fileIndex = this.fileList.findIndex(f => f === tempFileObj);
                                                    if (fileIndex !== -1) {
                                                        this.$set(this.fileList, fileIndex, {
                                                            status: 'done',
                                                            url: imageUrl,
                                                            imageId: imageId,
                                                            baseurl: imageBase64Url,
                                                            content: imageId // 添加content字段用于提交
                                                        });
                                                    }

                                                    this.$toast.success('图片上传成功');
                                                } catch (pcUploadError) {
                                                    console.error('PC环境上传失败:', pcUploadError);
                                                    throw pcUploadError; // 向外层抛出错误
                                                }
                                            }
                                        } catch (parseJsonError) {
                                            console.error('解析JSON数据失败:', parseJsonError, cleanData);
                                            this.$toast.fail('解析图片数据失败');
                                        }

                                        return; // 处理完base64图片后直接返回
                                    } else {
                                        // 处理其他格式的字符串数据
                                        try {
                                            const result = JSON.parse(data);
                                            console.log('解析后的上传结果:', result);
                                            // 这里可以添加对result的处理逻辑
                                        } catch (parseError) {
                                            console.error('解析上传结果失败:', parseError);
                                            this.$toast.fail('解析上传结果失败');
                                        }
                                    }
                                } else {
                                    // 处理非字符串类型的数据
                                    console.log('非字符串类型的上传结果:', data);
                                    // 这里可以添加对data的处理逻辑
                                }
                            } catch (error) {
                                console.error('处理上传结果时发生错误:', error);
                                this.$toast.fail('处理上传结果失败');
                            }
                        },
                        fail: (data) => {
                            console.error('文件上传失败:', data);
                            this.$toast.fail('图片上传失败');
                        }
                    });
                } else {
                    console.warn('lightAppJssdk.uploadFile不可用');
                    this.$toast.fail('上传功能不可用，请检查应用权限');
                    // 可以在这里添加备用的上传方法
                    this.takePictureFromNative();
                }
            } catch (error) {
                console.error('调用文件上传失败:', error);
                this.$toast.fail('上传功能异常');
            }
        },

        goToLists() {
            localStorage.setItem('searchRiverType', this.riverLabel.slice(2))
            this.$router.push({
                path: '/river-list',
                query: { from: 'complaint' }
            }).catch(err => {
                console.warn('Navigation error:', err);
            });
        },
        getCurrentLocation() {
            try {
                const options = {
                    timeout: 8000, // 超时时间
                    maximumAge: 30000, // 缓存时间
                    enableHighAccuracy: false // 不需要高精度，可以加快获取速度
                }

                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        position => {
                            const latitude = position.coords.latitude;
                            const longitude = position.coords.longitude;
                            console.log(`Latitude: ${latitude}, Longitude: ${longitude}`, 'navigator');
                            this.form.latitude = latitude;
                            this.form.longitude = longitude;
                        },
                        error => {
                            console.error('Error getting location', error);
                            // 根据错误类型给出不同提示
                            switch (error.code) {
                                case error.PERMISSION_DENIED:
                                    console.warn("用户拒绝了位置请求");
                                    break;
                                case error.POSITION_UNAVAILABLE:
                                    console.warn("位置信息不可用");
                                    break;
                                case error.TIMEOUT:
                                    console.warn("获取位置超时");
                                    break;
                                case error.UNKNOWN_ERROR:
                                    console.warn("未知错误");
                                    break;
                            }
                            // 使用IP定位作为备选方案
                            this.getIpLocation();
                        },
                        options
                    );
                } else {
                    console.warn('浏览器不支持地理位置');
                    // 使用IP定位作为备选方案
                    this.getIpLocation();
                }
            } catch (error) {
                console.error('获取位置异常:', error);
                this.form.latitude = 0;
                this.form.longitude = 0;
                // 使用IP定位作为备选方案
                this.getIpLocation();
            }
        },
        getIpLocation() {
            let that = this
            const xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function () {
                if (this.readyState == 4 && this.status == 200) {
                    const response = JSON.parse(xhttp.responseText);
                    const latitude = response.location.latitude;
                    const longitude = response.location.longitude;
                    console.log(`浏览器获取当前ip--Latitude: ${latitude}, Longitude: ${longitude}`, 'ip');
                    that.form.latitude = latitude;
                    that.form.longitude = longitude;
                    if (latitude === undefined || longitude === undefined) that.$toast.fail('无法获取当前位置');
                }
            };
            xhttp.open("GET", "https://api.ipapi.is/", true);
            xhttp.send();
        },
        // 预览图片
        previewImage(index) {
            if (this.fileList && this.fileList.length > 0) {
                const images = this.fileList.map(item => item.url || item.baseurl);
                this.$imagePreview({
                    images: images,
                    startPosition: index,
                    closeable: true
                });
            }
        },

        // 删除图片
        handleImageDeleteTest(item, index) {
            this.$dialog.confirm({
                title: '提示',
                message: '确定要删除这张图片吗？',
            }).then(() => {
                this.fileList.splice(index, 1);
                this.$toast.success('删除成功');
            }).catch(() => {
                // 取消删除
            });
        },

        // 使用原生相机功能
        takePictureFromNative() {
            try {
                if ('mediaDevices' in navigator && 'getUserMedia' in navigator.mediaDevices) {
                    const input = document.createElement('input');
                    input.type = 'file';
                    input.accept = 'image/*';
                    input.capture = 'camera';

                    input.onchange = (event) => {
                        const file = event.target.files[0];
                        if (file) {
                            const reader = new FileReader();
                            reader.onload = (e) => {
                                const imageBase64Url = e.target.result;

                                // 创建临时文件对象
                                const tempFileObj = {
                                    status: 'uploading',
                                    baseurl: imageBase64Url,
                                    message: '上传中...',
                                    url: imageBase64Url
                                };

                                this.fileList.push(tempFileObj);

                                // 创建FormData对象上传
                                const formData = new FormData();
                                formData.append('file', file);

                                // 上传图片
                                this.uploadImageFile(formData, tempFileObj, imageBase64Url);
                            };
                            reader.readAsDataURL(file);
                        }
                    };

                    input.click();
                } else {
                    this.$toast('您的设备不支持相机功能');
                }
            } catch (error) {
                console.error('调用相机功能失败:', error);
                this.$toast('相机调用失败，请重试');
            }
        },

        // 上传图片文件
        async uploadImageFile(formData, tempFileObj, imageBase64Url) {
            try {
                const response = await post('/common/upload', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });

                if (response.code === 200 && response.success && response.data) {
                    const imageId = response.data;

                    // 构建完整的图片URL
                    let imageUrl = IMAGE_BASE_URL;
                    if (!imageUrl.endsWith('/')) {
                        imageUrl += '/';
                    }
                    imageUrl += `common/image?id=${imageId}`;

                    // 添加token参数
                    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
                    if (token) {
                        imageUrl = imageUrl + (imageUrl.includes('?') ? '&' : '?') + `token=${encodeURIComponent(token)}`;
                    }

                    // 更新文件对象状态
                    const fileIndex = this.fileList.findIndex(f => f === tempFileObj);
                    if (fileIndex !== -1) {
                        this.$set(this.fileList, fileIndex, {
                            status: 'done',
                            url: imageUrl,
                            imageId: imageId,
                            baseurl: imageBase64Url,
                            content: imageId // 添加content字段用于提交
                        });
                    }

                    this.$toast.success('图片上传成功');
                } else {
                    throw new Error(response?.message || '上传失败');
                }
            } catch (error) {
                console.error('上传图片失败:', error);
                this.$toast.fail('图片上传失败');

                // 更新文件状态为失败
                const fileIndex = this.fileList.findIndex(f => f === tempFileObj);
                if (fileIndex !== -1) {
                    this.$set(this.fileList, fileIndex, {
                        status: 'failed',
                        url: imageBase64Url,
                        message: '上传失败',
                        baseurl: imageBase64Url,
                    });
                }
            }
        },
    }
}
</script>
<style scoped>
/* 相机按钮区域样式 */
.camera-buttons {
    margin: 16px 0;
}

.camera-buttons .van-button {
    height: 36px;
    border-radius: 18px;
    margin-right: 10px;
}

/* 图片预览容器样式 */
.image-preview-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
    gap: 12px;
    padding: 12px 0;
    margin-top: 10px;
}

/* 图片预览项样式 */
.image-preview-item {
    position: relative;
    aspect-ratio: 1;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* 预览图片样式 */
.preview-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

/* 图片删除图标样式 */
.image-delete-icon {
    position: absolute;
    top: 0;
    right: 0;
    width: 20px;
    height: 20px;
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0 0 0 4px;
    cursor: pointer;
    transition: background-color 0.2s;
}

.image-delete-icon:hover {
    background-color: rgba(0, 0, 0, 0.7);
}

/* 上传状态指示器 */
.upload-status {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 2px 4px;
    font-size: 10px;
    text-align: center;
    color: white;
    background-color: rgba(0, 0, 0, 0.5);
}

.upload-status.uploading {
    background-color: rgba(25, 137, 250, 0.7);
}

.upload-status.failed {
    background-color: rgba(237, 64, 20, 0.7);
}

/* 表单按钮样式 */
.form-buttons {
    margin: 16px;
    display: flex;
    gap: 10px;
}

.form-buttons .van-button {
    flex: 1;
    height: 40px;
    font-size: 16px;
    border-radius: 4px;
}
</style>